import { animate, state, style, transition, trigger } from '@angular/animations';

export const slideInAndOutAnimation = trigger('slideInAndOut', [
  state('in', style({ height: '*' })),
  transition(':enter', [style({ height: 0 }), animate(200)]),
  transition(':leave', animate(200, style({ height: 0 }))),
]);
